<template>
  <picture>
    <source v-bind="sourceParams" />
    <lazy-image
      :src="src"
      :alt="alt"
    />
  </picture>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import LazyImage from './lazyImage.vue';

  interface Props {
    alt: string;
    quality?: number;
    sizes?: string;
    src: string;
    srcSet?: number[];
    webp?: boolean;
  }

  const props = withDefaults(defineProps<Props>(), {
    alt: '',
    sizes: '',
    src: '',
    webp: false,
  });

  const setSrcSet = computed(() => {
    if (!props.srcSet) {
      return;
    }

    let str: string = '';
    const quality = props.quality ? `&quality=${props.quality}` : '';
    const webp = props.webp ? '&fmt=webp' : '';

    props.srcSet.forEach((el) => (str += `${props.src}?width=${el}${webp}${quality} ${el}w, `));
    str = str.replace(/, $/, '');

    return str;
  });

  const sourceParams = computed(() => ({
    sizes: props.sizes ? `${props.sizes}, 100vw` : '100vw',
    srcset: setSrcSet.value,
    type: props.webp ? 'image/webp' : 'image/jpeg',
  }));
</script>
